import { getCategoryPropertyValueRecord } from '../../../helpers/category-property-value-record.helpers';
import { omit } from '../../../helpers/object.helpers';
import { isEqualCategoryPropertyValueRecord } from '../../../helpers/recipe.helpers';
import {
  IElementCategory,
  ElementCategoryID,
  IElementCategoryQuantityPropertiesFn,
} from '../../../models/element-categories.model';
import { DEFAULT_QUANTITY_PROPERTIES } from '../../../models/element-quantities.model';
import { Orientation } from '../../../models/orientation.model';
import { thermalTransmittanceProperty } from '../properties';
import { wallProperties } from './wall.model';

const recipeFilter: IElementCategory['recipeFilter'] = (recipe, element) => {
  const category_property_value_record =
    getCategoryPropertyValueRecord(element);

  // Recipe category_property_value_record must be an EXACT to the element to appear
  return isEqualCategoryPropertyValueRecord(
    category_property_value_record,
    recipe.category_property_value_record,
  );
};

const getQuantityProperties: IElementCategoryQuantityPropertiesFn = () =>
  omit(DEFAULT_QUANTITY_PROPERTIES, 'density', 'mass', 'fill');

export const wall: IElementCategory = {
  id: ElementCategoryID.Wall,
  name: 'Wall',
  properties: wallProperties,
  optionalProperties: [thermalTransmittanceProperty],
  defaultSelectedQuantity: 'area_side',
  orientation: Orientation.Vertical,
  recipeFilter,
  getQuantityProperties,
  getElementPropertySelectionByProductId: () => undefined,
};
